/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import {
  hideModal,
  getEvolutionPlanTrainingPreRequisites,
  showModal,
} from "actions";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { withRouter } from "react-router-dom";
import { Trans } from "react-i18next";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import EvolutionPlanPreRequisiteBodyChild from "components/evolutionPlan/EvolutionPlanPreRequisite";
import "components/evolutionPlan/evoplan.css";

class EvolutionPlanPreRequisiteBody extends Component {
  state = {};

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.trainingId !== this.props.trainingId) {
      this.fetchData();
    }
  }

  fetchData = () => {
    this.props.getEvolutionPlanTrainingPreRequisites(
      this.props.trainingId,
      this.props.employeeId,
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  onSuccess = (file) => {
    this.props.onProcessEnd();
  };

  showPrerequisites = (trainingId, trainingName) => {
    console.log(this.props.employeeId, trainingId);

    // this.props.hideModal();
    this.props.showModal({
      modalType: "epPreReq",
      modalTitle: <EvolutionPlanPreRequisiteTitle />,
      modalContent: (
        <EvolutionPlanPreRequisiteBodyChild
          employeeId={this.props.employeeId}
          trainingId={trainingId}
          trainingName={`${this.props.trainingName} > ${trainingName}`}
        />
      ),
      modalFooter: null,
      modalCustomClassName: "modal-xl ttModal",
    });
  };

  renderTrainingMethodIcon = (value) => {
    switch (value) {
      case 3:
        return (
          <td>
            <span className="iconmford fo-icon-tv ">
              <span className="path1"></span>
              <span className="path2"></span>
              <span className="path3"></span>
              <span className="path4"></span>
            </span>
          </td>
        );
      case 1:
        return (
          <td>
            <span className="iconmford fo-icon-live-tv"></span>
          </td>
        );
      default:
        return (
          <td>
            <span className="iconmford fo-icon-class "></span>
          </td>
        );
    }
  };

  renderPreReqs = () => {
    return this.props.preReq.data.plans.map((p) => {
      return (
        <tr
          key={p.training.id}
          className={p.success ? "evoplan_preq_success" : null}
        >
          {this.renderTrainingMethodIcon(p.method?.value)}
          <td>{p.training.name}</td>
          <td>
            {p.duration} <sup><Trans desc="Gün">10388</Trans></sup>
          </td>
          <td>{p.weight.toFixed(2)}</td>
          <td>{p.futureWeight.toFixed(2)}</td>
          <td>
            {p.havePreRequisite ? (
              <a
                onClick={() =>
                  this.showPrerequisites(p.training.id, p.training.name)
                }
                className="btn btn-fga-view"
              >
                <Trans desc="Göster">10143</Trans> <span className="iconmford fo-icon-search"></span>
              </a>
            ) : null}
          </td>
        </tr>
      );
    });
  };

  render() {
    if (!this.props.preReq) {
      return this.props.spinner;
    }

    console.log(this.props.preReq);

    return (
      <>
        <div>{this.props.trainingName}</div>
        <table
          className="table display responsive tgE dataTable no-footer dtr-none collapsed"
          id="dataTablePersonel"
        >
          <thead>
            <tr>
              <th>
                <div className="tableTitle">
                  <Trans desc="Tür">10114</Trans>
                </div>
              </th>
              <th>
                <div className="tableTitle">
                  <Trans desc="Eğitim Adı">10115</Trans>
                </div>
              </th>
              <DesktopBreakpoint>
                <th>
                  <div className="tableTitle">
                    <Trans desc="Süre">10017</Trans>
                  </div>
                </th>
                <th>
                  <div className="tableTitle">
                    <Trans desc="Mevcut Dönem Eğitim Ağırlığı">10513</Trans>
                  </div>
                </th>
                <th>
                  <div className="tableTitle">
                    <Trans desc="Gelecek Dönem Eğitim Ağırlığı">10514</Trans>
                  </div>
                </th>
                <th>
                  <div className="tableTitle">
                    <Trans desc="Ön Şart">10159</Trans>
                  </div>
                </th>
              </DesktopBreakpoint>
            </tr>
          </thead>
          <tbody>{this.renderPreReqs()}</tbody>
        </table>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-default"
            onClick={this.props.hideModal}
          >
            <Trans desc="Kapat">10384</Trans>
          </button>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    profile: state.guide.data.find((p) => {
      return p.id === ownProps.id;
    }),
    application: state.application,
    preReq: state.evolutionPlan.data.preRequisites,
    modal: state.modal,
  };
};

export default connect(mapStateToProps, {
  hideModal,
  getEvolutionPlanTrainingPreRequisites,
  showModal,
})(containsLongRunningProcess(withRouter(EvolutionPlanPreRequisiteBody)));

export const EvolutionPlanPreRequisiteTitle = (props) => {
  return (
    <>
      <h5 className="modal-title">
        <Trans desc="Gelişim Planı Ön Şartlar">10383</Trans>
      </h5>
    </>
  );
};
